import { Text } from '@chakra-ui/react';
import SupportLink from 'src/components/intercom/SupportLink';

export default function ContactToManageNotice({
  action = 'make changes to or cancel your subscription',
}: {
  action?: string;
}) {
  return (
    <Text mt="12px">
      To {action}, please{' '}
      <SupportLink
        message="Hello! I'd like to make changes to or cancel my subscription."
        color="podcastPurple"
      >
        get in touch with us
      </SupportLink>{' '}
      and we&apos;ll be happy to help.
    </Text>
  );
}
